<template>
    <div :class="lastClick?'wisdom':'wisdom ptr'" @click="clicky">
        <span v-html="clicks[click]"></span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clicks: [
                "KLICKEN SIE MIT DEM MAUS",
                "BITTE NICHT MEHR KLICKEN",
                "HÖREN SIE SOFORT AUF ZU KLICKEN",
                "HALT DEN KLICKEN!!!",
                "J'ÉTAIS OFFENSÉ"
            ],
            click: 0
        }
    },

    computed: {
        lastClick() {
            const r = this.click >= (this.clicks.length - 1);
            return r;
        }
    },

    methods: {
        clicky() {
            if (!this.lastClick) {
                this.click++;
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/KlickenMaus.vue